import $ from 'jquery'
import { mixinJleague } from './vue/mixin/utility'

$(function(){
	// password show/hide
	$('.pwSwitch').each(function(){
		$(this).on('click',function(){
			var input = $(this).closest('.pswdShowHide').find('input');
			if($(input).attr('type') === 'password'){
				$(input).attr('type','text');
				$(this).addClass('show');
			}else{
				$(input).attr('type','password');
				$(this).removeClass('show');
			}
		});
	});
});

export function setErrorMessage(error, self){
    const response = error.response;
    switch (response.status) {
        case 404:
            if (!response.data.redirect_uri) {
                self.errorMessage.innerText = '予期しないエラーが発生しました。システム管理者にお問い合わせください。(' + error + ')';
            } else {
                location.href = mixinJleague.methods.addUrlParams(response.data.redirect_uri, {
                    require: 'email'
                });
            }
            break;
        case 400:
        case 401:
        case 403:
            self.errorMessage.innerText = 'ユーザー名またはパスワードが違います。';
            break;
        case 409:
            self.errorMessage.innerText = '異なるＪリーグIDでご利用中のアカウントです。';
            break;
        case 500:
            self.errorMessage.innerText = '予期しないエラーが発生しました。システム管理者にお問い合わせください。(' + response.data.message + ')';
            break;
        default:
            self.errorMessage.innerText = '予期しないエラーが発生しました。システム管理者にお問い合わせください。(' + error + ')';
            break;
    };
};

// urlフラグメント関数
export function checkFlagment() {
    const hash = location.hash;
    let retVal = {
        mkdb_id: null,
        access_token: null,
        external_id: null
    };
    if (hash.length === 0) {
        return retVal;
    }
    // 一文字目が、#なので、sliceしてからsplitする
    let params = hash.slice(1).split("&");
    if (params.length < 2) {
        return retVal;
    }
    let original_client_id = null;
    let original_redirect_uri = null;
    retVal.mkdb_id = params[0];
    for (let param of params) {
        const key_vals = param.split("=");
        if (key_vals.length === 2) {
            if (key_vals[0] === "mkdb_id") {
                retVal.mkdb_id = key_vals[1];
            }
            if (key_vals[0] === "external_id") {
                retVal.external_id = key_vals[1];
            }
            if (key_vals[0] === "access_token") {
                retVal.access_token = key_vals[1];
            }
            if (key_vals[0] === "original_client_id") {
                original_client_id = key_vals[1];
            }
            if (key_vals[0] === "original_redirect_uri") {
                original_redirect_uri = encodeURIComponent(key_vals[1]);
            }
        }
    }
    if (original_client_id && original_redirect_uri) {
        const url = "https://login2.jleague.jp/home?client_id=" +
            original_client_id +
            "&redirect_uri=" + original_redirect_uri;
        const iframe = '<iframe width="0" height="0" src="' + url + '"></iframe>';
        $("html").append(iframe);
    }
    return retVal;
}

// URLパラメータ取得用関数
export function getParameter(url){
    var paramsArray = [];
    let parameters = '';

    parameters = url.split("#");
    if(parameters.length > 1){
        url = parameters[0];
    }
    parameters = url.split("?");
    if(parameters.length > 1){
        var params = parameters[1].split("&");
        for (let i = 0; i < params.length; i++){
            var paramItem = params[i].split("=");
            paramsArray[paramItem[0]] = paramItem[1];
        }
    }
    return paramsArray;
};

// URLパラメータ設定用関数
export function setParameter(paramsArray, url){
    var resurl = null;
    try {
        resurl = new URL(url);
    } catch (e) {
        if (e instanceof TypeError) {
            resurl = new URL(url,location.href);
        }
    }
    if (resurl === null) {
        return url;
    }
    for (let key in paramsArray){
        if(paramsArray.hasOwnProperty(key)) {
            resurl.searchParams.set(key, paramsArray[key]);
        }
    }
    return resurl.href;
}

// URLパス取得用関数
export function getPath(url) {
    // パスとパラメータに分けた後にパラメータ部を除外する
    var path = url.split("/").slice(3).join().split("?").slice(0, 1).join();
    path == "" ? "/" : path;
    return path;
}
